"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.reflect.get.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.get-prototype-of.js");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var EmptyMiddleware = require('./EmptyMiddleware');

var multiauth = require('../multiauth');

var _require = require('../multiauth/keychain'),
    kcLoggedIn = _require.kcLoggedIn,
    kcSign = _require.kcSign;

var _require2 = require('../utils'),
    delay = _require2.delay;

var _require3 = require('../api/transports/http'),
    RPCError = _require3.RPCError;

var MultiAuthMiddleware =
/*#__PURE__*/
function (_EmptyMiddleware) {
  _inherits(MultiAuthMiddleware, _EmptyMiddleware);

  var _super = _createSuper(MultiAuthMiddleware);

  function MultiAuthMiddleware() {
    _classCallCheck(this, MultiAuthMiddleware);

    return _super.apply(this, arguments);
  }

  _createClass(MultiAuthMiddleware, [{
    key: "_checkPendingAllowed",
    value: function () {
      var _checkPendingAllowed2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tx) {
        var url, xhr, res, requiredPerms, ret;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new URL('/api/oauth/check/' + multiauth.clientId(), multiauth.apiHost());
                xhr = new XMLHttpRequest();
                xhr.open('POST', url.toString(), false);
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                  tx: tx
                }));
                res = JSON.parse(xhr.responseText);
                requiredPerms = res.requiredPerms;
                ret = {
                  allowed: true
                };

                if (!(requiredPerms && requiredPerms.length)) {
                  _context.next = 14;
                  break;
                }

                ret.allowed = false;
                ret.txHash = multiauth._hashOps(tx.operations);
                _context.next = 13;
                return multiauth.login([], {
                  extraParams: '?ops_hash=' + ret.txHash
                });

              case 13:
                ret.win = _context.sent;

              case 14:
                return _context.abrupt("return", ret);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _checkPendingAllowed(_x) {
        return _checkPendingAllowed2.apply(this, arguments);
      }

      return _checkPendingAllowed;
    }()
  }, {
    key: "_preparePending",
    value: function () {
      var _preparePending2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(tx, txHash) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return multiauth._callApi('/api/oauth/prepare_pending', {
                  tx: tx,
                  txHash: txHash
                });

              case 2:
                res = _context2.sent;
                _context2.next = 5;
                return res.json();

              case 5:
                res = _context2.sent;

                if (!(res.status === 'ok')) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                if (!res.error) {
                  _context2.next = 14;
                  break;
                }

                throw new Error(json.error);

              case 14:
                throw new Error('Internal Server Error');

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _preparePending(_x2, _x3) {
        return _preparePending2.apply(this, arguments);
      }

      return _preparePending;
    }()
  }, {
    key: "_waitForPending",
    value: function () {
      var _waitForPending2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(txHash) {
        var interval, max, loop;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                interval = 2 * 1000;
                max = interval * 30;

                loop =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3() {
                    var waited,
                        res,
                        json,
                        forbidden,
                        err,
                        _res,
                        _args3 = arguments;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            waited = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 0;
                            _context3.next = 3;
                            return delay(interval);

                          case 3:
                            _context3.next = 5;
                            return multiauth._callApi('/api/oauth/wait_for_pending/' + txHash);

                          case 5:
                            res = _context3.sent;
                            _context3.next = 8;
                            return res.json();

                          case 8:
                            json = _context3.sent;

                            if (!(json.status === 'ok')) {
                              _context3.next = 16;
                              break;
                            }

                            forbidden = json.forbidden, err = json.err, _res = json.res;

                            if (!forbidden) {
                              _context3.next = 13;
                              break;
                            }

                            throw new Error('Transaction forbidden');

                          case 13:
                            return _context3.abrupt("return", {
                              err: err,
                              res: _res
                            });

                          case 16:
                            waited += interval;

                            if (!(waited >= max)) {
                              _context3.next = 21;
                              break;
                            }

                            throw new Error('Transaction timeouted');

                          case 21:
                            _context3.next = 23;
                            return loop(waited);

                          case 23:
                            return _context3.abrupt("return", _context3.sent);

                          case 24:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function loop() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context4.next = 5;
                return loop();

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _waitForPending(_x4) {
        return _waitForPending2.apply(this, arguments);
      }

      return _waitForPending;
    }()
  }, {
    key: "_processPending",
    value: function () {
      var _processPending2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(tx) {
        var _yield$this$_checkPen, allowed, win, txHash, closeWin, res, err, result;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._checkPendingAllowed(tx);

              case 2:
                _yield$this$_checkPen = _context5.sent;
                allowed = _yield$this$_checkPen.allowed;
                win = _yield$this$_checkPen.win;
                txHash = _yield$this$_checkPen.txHash;

                if (allowed) {
                  _context5.next = 34;
                  break;
                }

                closeWin = function closeWin() {
                  if (win && !win.closed) {
                    win.close();
                  }

                  ;
                };

                _context5.prev = 8;
                _context5.next = 11;
                return this._preparePending(tx, txHash);

              case 11:
                _context5.next = 18;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](8);
                console.error('_preparePending', _context5.t0);
                closeWin();
                throw _context5.t0;

              case 18:
                _context5.prev = 18;
                _context5.next = 21;
                return this._waitForPending(txHash);

              case 21:
                result = _context5.sent;
                res = result.res;
                err = result.err;
                _context5.next = 31;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t1 = _context5["catch"](18);
                console.error('_waitForPending', _context5.t1);
                closeWin();
                throw _context5.t1;

              case 31:
                return _context5.abrupt("return", {
                  broadcast: false,
                  res: res,
                  err: err
                });

              case 34:
                return _context5.abrupt("return", {
                  broadcast: true
                });

              case 35:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 13], [18, 26]]);
      }));

      function _processPending(_x5) {
        return _processPending2.apply(this, arguments);
      }

      return _processPending;
    }()
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref2) {
        var tx, privKeys, orig, prepareTx, result, kcState, _result, err, t;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                tx = _ref2.tx, privKeys = _ref2.privKeys, orig = _ref2.orig, prepareTx = _ref2.prepareTx;
                result = {
                  broadcast: true
                };

                if (!(tx._meta && tx._meta._keys)) {
                  _context6.next = 19;
                  break;
                }

                _context6.next = 5;
                return kcLoggedIn();

              case 5:
                kcState = _context6.sent;

                if (!(kcState && kcState.authorized)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 9;
                return prepareTx(tx);

              case 9:
                tx = _context6.sent;
                _context6.next = 12;
                return kcSign({
                  tx: tx
                });

              case 12:
                tx = _context6.sent;

                if (!tx) {
                  result.broadcast = false;
                  result.err = new Error('Forbidden by KeyChain user');
                }

                _context6.next = 19;
                break;

              case 16:
                _context6.next = 18;
                return this._processPending(tx);

              case 18:
                result = _context6.sent;

              case 19:
                if (!result.broadcast) {
                  _context6.next = 25;
                  break;
                }

                _context6.next = 22;
                return _get(_getPrototypeOf(MultiAuthMiddleware.prototype), "broadcast", this).call(this, {
                  tx: tx,
                  privKeys: privKeys,
                  orig: orig
                });

              case 22:
                return _context6.abrupt("return", _context6.sent);

              case 25:
                if (!result.res) {
                  _context6.next = 27;
                  break;
                }

                return _context6.abrupt("return", result.res);

              case 27:
                _result = result, err = _result.err; // http

                if (!(err && err.name === 'RPCError')) {
                  _context6.next = 30;
                  break;
                }

                throw new RPCError(err, err);

              case 30:
                if (!(err && err.message)) {
                  _context6.next = 34;
                  break;
                }

                t = new Error(err.message);
                t.payload = err.payload;
                throw t;

              case 34:
                console.error('MultiAuthMiddleware broadcast', err);

              case 35:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function broadcast(_x6) {
        return _broadcast.apply(this, arguments);
      }

      return broadcast;
    }()
  }]);

  return MultiAuthMiddleware;
}(EmptyMiddleware);

module.exports = MultiAuthMiddleware;